import classNames from 'classnames';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';

interface ContactInformationFormProps {
  className?: string;
  initialContactData?: any;
  onUpdate: (data: any) => void; // Function to update form data in parent component
}

const ContactInformationForm = ({ className, onUpdate, initialContactData }: ContactInformationFormProps) => {

  // State to store the form data
  const [formData, setFormData] = useState<any>({
    name: '',
    role: '',
    email: '',
    phone: '',
    company_name: '',
    title: ''
  });

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    onUpdate({ ...formData, [name]: value }); // Update the parent component's formData on every change
  };

  useEffect(() => {
    if (initialContactData) {
      setFormData({
        name: initialContactData['name'],
        role: initialContactData['role'],
        email: initialContactData['email'],
        phone: initialContactData['phone'],
        company_name: initialContactData['company_name'],
        title: initialContactData['title'],
      });
    }


  }, [initialContactData]);

  return (
    <>
      <h4 className="mb-3">Contact Information</h4>

      <Row className={classNames('g-3', className)}>
        <Col sm={6} md={4}>
          <FloatingLabel controlId="title" label="Title">
            <Form.Control type="text" placeholder="Title"
              name='title' value={formData.title} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>

        <Col sm={6} md={4}>
          <FloatingLabel controlId="contact-name" label="Contact name">
            <Form.Control type="text" placeholder="Contact name" required
              name='name' value={formData.name} onChange={handleInputChange} />
          </FloatingLabel>
        </Col>

        <Col sm={6} md={4}>
          <FloatingLabel controlId="role" label="Role">
            <Form.Control type="text" placeholder="Role"
              name='role' value={formData.role} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>

        <Col sm={6} md={4}>
          <FloatingLabel controlId="company" label="Company">
            <Form.Control type="text" placeholder="Company"
              name='company_name' value={formData.company_name} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>

        <Col sm={6} md={4}>
          <FloatingLabel controlId="email" label="Email">
            <Form.Control type="email" placeholder="Email"
              name='email' value={formData.email} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>

        <Col sm={6} md={4}>
          <FloatingLabel controlId="phone" label="Phone">
            <Form.Control
              type="number"
              placeholder="Phone"
              className="input-spin-none"
              name='phone' value={formData.phone} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>

      </Row>
    </>
  );
};

export default ContactInformationForm;

